module.exports = __webpack_public_path__ + "img/17854_S.a128c654.png";